import * as React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Button, FormLabel, FormControlLabel, RadioGroup, Radio } from "@mui/material";
import {
  ButtonsContainer,
  FieldContainer,
  FormContainer,
  MultiFieldContainer,
  SectionContainer,
  SectionTitle,
} from "./ClassesForm.styled";
import InputField from "../../../../components/formFields/InputField";
import SelectField from "../../../../shared/components/SelectField";
import DatePickerField from "../../../../shared/components/DatePickerField";
import { useCreateAssessmentClassBMutation, useGetNaicMemberQuery, useUpdateAssessmentClassBMutation } from "../../../../services/InsuranceService";
import dayjs from "dayjs";
import SearchableSelect from "../../../../components/formFields/SearchableSelect";
import { LoadingPanel } from "../../../../shared/components/LoadingPanel";

export const ClassBForm = (props) => {
  const { onClose, data: initialData } = props;
  const { data: naicMembers, isLoading } = useGetNaicMemberQuery('', {});

  const [createAssesmentClassB, {isLoading: isAssesmentCreating}] = useCreateAssessmentClassBMutation("");
  const [updateAssesmentClassB, {isLoading: isAssesmentUpdating}] = useUpdateAssessmentClassBMutation("");


  const initialValues = initialData ? initialData : {
    premiumYear: "",
    callAmountsLife: "",
    callAmountsHealth: "",
    callAmountsAllocatedAnnuity: "",
    callAmountsUnallocatedAnnuity: "",
    minimumInvoice: "",
    comments: "",
  };

  const validationSchema = Yup.object().shape({
    // naicCode: Yup.string().required("NAIC Code is required"),
    premiumYear: Yup.string(),
    callAmountsLife: Yup.number().required("Amount is required"),
    callAmountsHealth: Yup.number().required("Amount is required"),
    callAmountsAllocatedAnnuity: Yup.number().required("Amount is required"),
    callAmountsUnallocatedAnnuity: Yup.number().required("Amount is required"),
    minimumInvoice: Yup.number().required("Minimum invoice is required"),
  });
  const handleSubmit = (values) => {
    !initialData ? createAssesmentClassB({
      naicCode: values.naicCode?.naicCode,
      memberId: values.naicCode?.id === 0 ? 0 : null,
      memberName: values.naicCode?.memberName,
      premiumYear: dayjs(values.premiumYear).year().toString(),
      callAmountsLife: Number(values.callAmountsLife),
      callAmountsHealth: Number(values.callAmountsHealth),
      callAmountsAllocatedAnnuity: Number(values.callAmountsAllocatedAnnuity),
      callAmountsUnallocatedAnnuity: Number(values.callAmountsUnallocatedAnnuity),
      minimumInvoice: Number(values.minimumInvoice),
      comments: values.comments,
    }) : updateAssesmentClassB({
      id: initialData?.id,
      naicCode: values.naicCode?.naicCode,
      memberId: values.naicCode?.id === 0 ? 0 : null,
      memberName: values.naicCode?.memberName,
      premiumYear: dayjs(values.premiumYear).year().toString(),
      callAmountsLife: Number(values.callAmountsLife),
      callAmountsHealth: Number(values.callAmountsHealth),
      callAmountsAllocatedAnnuity: Number(values.callAmountsAllocatedAnnuity),
      callAmountsUnallocatedAnnuity: Number(values.callAmountsUnallocatedAnnuity),
      minimumInvoice: Number(values.minimumInvoice),
      comments: values.comments,
    })
    onClose()
  };

  const getInputComponent = (item) => {
    switch (item?.type) {
      case "date":
        return (
          <Field name={item.name}>
            {({ field, form }) => (
              <FieldContainer>
                <DatePickerField
                  name={item.name}
                  label={item.label}
                  value={field.value}
                  setValue={form.setFieldValue}
                  error={form.errors[item.name]}
                  maxDate={new Date()}
                  width={"100%"}
                  isYearSelect
                  // disabled
                />
              </FieldContainer>
            )}
          </Field>
        );
      case "number":
        return (
          <FieldContainer>
            <InputField
              name={item.name}
              label={item.label}
              fullWidth
              mode="decimal"
            />
          </FieldContainer>
        );
      case "searchableSelect":
        return (
              <FieldContainer>
                <SearchableSelect
                  name={item.name}
                  label={item.label}
                  fullWidth
                  multiline
                  options={naicMembers}
                  isDisabled={!!initialData}
                />
              </FieldContainer>
        );
      default:
        return (
          <FieldContainer>
            <InputField name={item.name} label={item.label} isDisabled={item.isDisabled} fullWidth />
          </FieldContainer>
        );
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {({ values, handleChange }) => (
        <Form id={"classBForm"}>
          {isLoading || isAssesmentCreating || isAssesmentUpdating && <LoadingPanel />}
          <FormContainer>
            <SectionContainer>
              {getInputComponent({
                name: "naicCode",
                label: "NAIC Code:",
                type: "searchableSelect",
              })}

              {getInputComponent({
                name: "premiumYear",
                label: "Premium Year:",
                type: "date",
              })}

              {getInputComponent({
                name: "callAmountsLife",
                label: "Call Amounts Life:",
                type: "number",
              })}

              {getInputComponent({
                name: "callAmountsHealth",
                label: "Call Amounts Health:",
                type: "number",
              })}

              {getInputComponent({
                name: "callAmountsAllocatedAnnuity",
                label: "Call Amounts Allocated Annuity:",
                type: "number",
              })}

              {getInputComponent({
                name: "callAmountsUnallocatedAnnuity",
                label: "Call Amounts Unallocated Annuity:",
                type: "number",
              })}

              {getInputComponent({
                name: "minimumInvoice",
                label: "Minimum Invoice:",
                type: "number",
              })}

              {getInputComponent({
                name: "comments",
                label: "Comments:",
                type: "text",
              })}

              <ButtonsContainer>
                <Button variant="outlined" type="submit">
                  {`${initialData ? 'Edit' : 'Create'} Assessment`}
                </Button>
                <Button variant="outlined" type="reset" onClick={onClose}>
                  Cancel
                </Button>
              </ButtonsContainer>
            </SectionContainer>
          </FormContainer>
        </Form>
      )}
    </Formik>
  );
};
